import { Select, TextInput } from "./form";
import { MutedText } from "./text";
import { Constants } from "../constants";

export function TtsVoiceControl(modelName, value, props = {}) {
    const model = Constants.TtsModels[modelName];
    if (!model) {
        return TextInput(null, "Enable text-to-speech to choose a voice", {
            value: "",
            disabled: true,
            ...props
        });
    }

    const selectedValue = value && (model.allowCustomVoice || model.voices.includes(value))
        ? value
        : model.defaultVoice;

    return model.allowCustomVoice
        ? TextInput(null, model.defaultVoice, { value: selectedValue, ...props })
        : Select({
            value: selectedValue,
            items: model.voices.map(voice => ({ value: voice, text: voice })),
            ...props
        });
}

export function TtsVoiceHint(modelName, props = {}) {
    const model = Constants.TtsModels[modelName];
    if (!model) {
        return MutedText("Enable text-to-speech to see the available voices.", props);
    }

    return MutedText(
        model.allowCustomVoice
            ? `Documented preset for ${model.name}: ${model.voices.join(", ")}. Other presets may depend on NagaAI provider routing.`
            : `Available voices for ${model.name}: ${model.voices.join(", ")}.`,
        props
    );
}
